import { render } from "./vendor-categories.vue?vue&type=template&id=8dca9590&scoped=true"
import script from "./vendor-categories.vue?vue&type=script&lang=js"
export * from "./vendor-categories.vue?vue&type=script&lang=js"

import "./vendor-categories.vue?vue&type=style&index=0&id=8dca9590&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dca9590"]])

export default __exports__